const TEXT_EXTENSIONS = new Set([
  "txt", "md", "mdx", "json", "jsonc", "js", "jsx", "ts", "tsx", "mjs", "cjs",
  "html", "htm", "css", "scss", "sass", "less", "xml", "svg", "yml", "yaml", "toml",
  "ini", "env", "gitignore", "dockerignore", "sh", "bash", "zsh", "ps1", "bat", "cmd",
  "py", "rb", "php", "go", "rs", "java", "kt", "kts", "c", "h", "cpp", "hpp", "cs",
  "swift", "vue", "svelte", "sql", "graphql", "gql", "prisma", "lua", "r", "dart", "ex",
  "exs", "erl", "hrl", "fs", "fsx", "gradle", "properties", "csv", "tsv", "lock",
]);

export function normalizeProjectPath(input: string): string {
  const raw = input.replace(/\\/g, "/").trim();
  if (!raw || raw.startsWith("/") || /^[a-zA-Z]:/.test(raw)) {
    throw new Error("Le chemin doit être relatif au projet.");
  }
  if (/\0|[\u0001-\u001f\u007f]/.test(raw)) {
    throw new Error("Le chemin contient un caractère interdit.");
  }
  const parts = raw.split("/");
  if (parts.some((part) => !part || part === "." || part === "..")) {
    throw new Error("Le chemin contient un segment interdit.");
  }
  const normalized = parts.join("/");
  if (normalized.length > 512) throw new Error("Le chemin est trop long.");
  return normalized;
}

export function fileExtension(path: string): string {
  const name = path.split("/").at(-1) ?? "";
  if (name.startsWith(".") && !name.slice(1).includes(".")) return name.slice(1).toLowerCase();
  return name.includes(".") ? name.split(".").at(-1)!.toLowerCase() : "";
}

export function isKnownTextPath(path: string): boolean {
  const name = path.split("/").at(-1)?.toLowerCase() ?? "";
  return TEXT_EXTENSIONS.has(fileExtension(path)) || ["dockerfile", "makefile", "license"].includes(name);
}

export function languageForPath(path: string): string {
  const extension = fileExtension(path);
  const map: Record<string, string> = {
    js: "javascript", jsx: "javascript", mjs: "javascript", cjs: "javascript",
    ts: "typescript", tsx: "typescript", json: "json", jsonc: "json", md: "markdown", mdx: "markdown",
    html: "html", htm: "html", css: "css", scss: "scss", less: "less", py: "python",
    rs: "rust", go: "go", java: "java", kt: "kotlin", c: "c", h: "c", cpp: "cpp", hpp: "cpp",
    cs: "csharp", php: "php", rb: "ruby", sh: "shell", bash: "shell", ps1: "powershell",
    sql: "sql", xml: "xml", svg: "xml", yaml: "yaml", yml: "yaml", toml: "ini", ini: "ini",
    lua: "lua", r: "r", dart: "dart", graphql: "graphql", gql: "graphql", vue: "html", svelte: "html",
  };
  return map[extension] ?? "plaintext";
}

export function slugify(value: string): string {
  return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
    .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 80) || "projet";
}

export function displayNameFromPath(path: string): string {
  return path.split("/").at(-1) ?? path;
}
